import { KIOS_STORAGE } from 'api/API_App';

export const pdfFileParser = (path: string): { to: string; fileName: string } => {
  const fileName = path.split('/').pop() || '';
  const trimStorage = path.replace(/\/storage\//, '');
  const formattedSpace = trimStorage.replace(/\s/g, '%20');

  const to = `${KIOS_STORAGE}/${formattedSpace}`;

  return {
    to,
    fileName,
  };
};
